<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoFlow
      :workflow-id="FlowType.ImbpBooking"
      :account-number="accountNumber"
      title="IMBP Appointments"
      @closed="flowClosed()"
    />
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoFlow from "@/flows/SoFlow.vue"
  import { FlowType } from "@/flows/useCases"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { jobTypes } from "@/constants/imbp"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: {
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoFlow,
    },
    data() {
      return {
        FlowType,
        accountNumber: useCurrentAccountStore().accountNumber,
        current: useCurrentAccountStore(),
        jobTypes,
      }
    },
    computed: {
      isLoading() {
        return (
          this.current.imbpAccount.isFetching ||
          this.current.imbpAvailability.isFetching
        )
      },
    },
    methods: {
      flowClosed() {
        this.$router.push({ name: RouteNames.CustomerMeterpoints })
      },
    },
  })
</script>
